"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSmoking = createSmoking;
const events_1 = require("../../../events");
const smoking_1 = require("../../../forms/htx/risks/smoking");
const queries_1 = require("../queries");
const messages = {
    smoking: {
        id: "ktx.dashboard.smoking",
        defaultMessage: "Dohányzás"
    },
    currentlySmoking: {
        id: "ktx.dashboard.smoking.currently_smoking",
        defaultMessage: "Aktuálisan dohányzik"
    },
    packYears: {
        id: "ktx.dashboard.kidney_disease_ethiology.pack_years",
        defaultMessage: "Csomagév"
    }
};
function createSmoking({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.smoking);
    if (event === undefined) {
        return undefined;
    }
    const currentlySmoking = {
        type: "list-item",
        label: formatMessage(messages.currentlySmoking),
        value: formatMessageMap(smoking_1.currentlySmokingMessages, event.value.currentlySmoking)
    };
    let items = [currentlySmoking];
    if (event.value.cigarettesPackYears) {
        const packYears = {
            type: "list-item",
            label: formatMessage(messages.packYears),
            value: `${event.value.cigarettesPackYears.packYears}`
        };
        items = [currentlySmoking, packYears];
    }
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.smoking),
        items
    };
}
